<template>
	<div class="login-vue" :style="bg">
		<div class="container">
			<p class="title">
				<img style="width:30px;margin-right:10px" src="../assets/imgs/logo.gif" />山东拙诚智能科技
			</p>
			<div class="input-c">
				<Input prefix="ios-contact" v-model="username" placeholder="用户名" clearable />
				<p class="error">{{accountError}}</p>
			</div>
			<div class="input-c">
				<Input type="password" v-model="password" prefix="md-lock" placeholder="密码" clearable
					@keyup.enter.native="enter" />
				<p class="error">{{pwdError}}</p>
			</div>
			<Button :loading="isShowLoading" class="submit" type="primary" @click="submit">登录</Button>
		</div>
	</div>
</template>

<script>
	import {
		menusToRoutes
	} from '../utils'

	export default {
		name: "builder_login",
		data() {
			return {
				username: "",
				password: "",
				accountError: "",
				pwdError: "",
				isShowLoading: false,
				bg: {}
			};
		},
		created() {
			this.bg.backgroundImage =
				"url(" +
				require("../assets/imgs/bg0" + new Date().getDay() + ".jpg") +
				")";
		},
		watch: {
			$route: {
				handler: function(route) {
					this.redirect = route.query && route.query.redirect;
				},
				immediate: true
			}
		},
		methods: {
			enter() {
				this.submit();
			},
			verifyAccount(e) {
				if (this.account !== "admin") {
					this.accountError = "请输入账号";
				} else {
					this.accountError = "";
				}
			},
			verifyPwd(e) {
				if (this.pwd !== "admin") {
					this.pwdError = "请输入密码";
				} else {
					this.pwdError = "";
				}
			},
			register() {
				console.log("注册账号");
			},
			forgetPwd() {
				console.log("忘记密码");
			},
			submit() {
				this.isShowLoading = true;
				var that = this;
				$.ajax({
					url: "/api/meter/builderLoginCheck",
					type: "post",
					data: {
						username: that.username,
						password: that.password
					},
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						localStorage.setItem('builder-token', '1');
						that.$router.push({
							path: that.redirect || '/mobile/builder/home'
						});
					},
					error: function() {

					},
					complete: function() {
						that.isShowLoading = false;
					}
				});
			}
		}
	};
</script>

<style>
	.login-vue {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
	}

	.login-vue .container {
		background: rgba(255, 255, 255, 0.5);
		width: 300px;
		text-align: center;
		border-radius: 10px;
		padding: 30px;
	}

	.login-vue .ivu-input {
		background-color: transparent;
		color: #fff;
		outline: #fff;
		border-color: #fff;
	}

	.login-vue ::-webkit-input-placeholder {
		/* WebKit, Blink, Edge */
		color: rgba(255, 255, 255, 0.8);
	}

	.login-vue :-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: rgba(255, 255, 255, 0.8);
	}

	.login-vue ::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: rgba(255, 255, 255, 0.8);
	}

	.login-vue :-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: rgba(255, 255, 255, 0.8);
	}

	.login-vue .title {
		font-size: 16px;
		margin-bottom: 20px;
	}

	.login-vue .input-c {
		margin: auto;
		width: 200px;
	}

	.login-vue .error {
		color: red;
		text-align: left;
		margin: 5px auto;
		font-size: 12px;
		padding-left: 30px;
		height: 20px;
	}

	.login-vue .submit {
		width: 200px;
	}

	.login-vue .account {
		margin-top: 30px;
	}

	.login-vue .account span {
		cursor: pointer;
	}

	.login-vue .ivu-icon {
		color: #eee;
	}

	.login-vue .ivu-icon-ios-close-circle {
		color: #777;
	}
</style>
